/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc Matches and converts xs:numeric to float
 */
import BaseMatcher from './BaseMatcher.js';
import DashConstants from '../../constants/DashConstants.js';

const numericRegex = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/;

const StringAttributeList = [ DashConstants.ID ]

// DescriptorType@value is xs:string; converting numeric-looking values would alter them (e.g. "01" -> 1)
const StringValueTagList = [
    DashConstants.ACCESSIBILITY,
    DashConstants.ASSET_IDENTIFIER,
    DashConstants.AUDIO_CHANNEL_CONFIGURATION,
    DashConstants.CLIENT_DATA_REPORTING,
    DashConstants.CONTENT_PROTECTION,
    DashConstants.ESSENTIAL_PROPERTY,
    DashConstants.FRAME_PACKING,
    DashConstants.OUTPUT_PROTECTION,
    DashConstants.RATING,
    DashConstants.REPORTING,
    DashConstants.ROLE,
    DashConstants.SERVICE_DESCRIPTION_SCOPE,
    DashConstants.SUPPLEMENTAL_PROPERTY,
    DashConstants.UTC_TIMING,
    DashConstants.VIEWPOINT
]

class NumericMatcher extends BaseMatcher {
    constructor() {
        super(
            (tagName, attrName, value) => numericRegex.test(value) &&
                StringAttributeList.indexOf(attrName) === -1 &&
                !(attrName === DashConstants.VALUE && StringValueTagList.indexOf(tagName) !== -1),
            str => parseFloat(str)
        );
    }
}

export default NumericMatcher;
